import React, { Component } from "react";
import { Button, Accordion } from "react-bootstrap";

class PaidFeeCard extends Component {
  render() {
    var total = 0;
    return (
      <div className="border shadow-sm rounded mb-3 p-3">
        <div className="th-12 th-medium th-cap">{this.props.title}</div>
        <div className="">
          <Accordion defaultActiveKey={null}>
            <div>
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="1"
                style={{
                  padding: 0,
                  textDecoration: "none",
                  boxShadow: "none",
                  width: "100%",
                }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <div className="th-12 th-black text-left">
                      Total: <span className="th-roboto">₹</span>{" "}
                      {this.props.amountPaid}
                    </div>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="th-grey th-12 pr-1">Details</div>
                    <i
                      className="fa fa-angle-down th-primary"
                      aria-hidden="true"
                    ></i>
                  </div>
                </div>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="1">
                <div className="mt-2">
                  {this.props.detail?.map((item, index) => {
                    total += item.fee_type_amount;
                    var eachTotal = 0;
                    return (
                      <React.Fragment>
                        <div
                          key={index}
                          className="th-12 th-grey th-bold text-left"
                        >
                          {item.fee_group__term_fee__term_name}
                        </div>
                        {item.term_fee_details.map((eachFee, index) => {
                          eachTotal += eachFee.fee_type_paid_amount;
                          return (
                            <React.Fragment>
                              <div
                                key={index}
                                className="d-flex justify-content-between"
                              >
                                <div className="th-12 th-grey th-medium text-left">
                                  {eachFee.fee_type__type_name}:
                                </div>
                                <div className="th-12 th-grey text-left">
                                  <span className="th-roboto">₹</span>{" "}
                                  {eachFee.fee_type_paid_amount}
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        })}
                        <div className="d-flex justify-content-between pb-2">
                          <div className="th-12 th-grey th-medium text-left">
                            Total
                          </div>
                          <div className="th-12 th-grey text-left">
                            <span className="th-roboto">₹</span> {eachTotal}
                          </div>
                        </div>{" "}
                        {}
                      </React.Fragment>
                    );
                  })}
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </div>
      </div>
    );
  }
}
export default PaidFeeCard;
